import { render, staticRenderFns } from "./asset-header.vue?vue&type=template&id=7a1cb380&"
import script from "./asset-header.vue?vue&type=script&lang=js&"
export * from "./asset-header.vue?vue&type=script&lang=js&"
import style0 from "./asset-header.vue?vue&type=style&index=0&id=7a1cb380&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports